export default __webpack_public_path__ + "static/media/easy_customization.161ecaa0.svg";